import { ImageProps } from 'next/image'
import { TcPageTemplateNames } from 'src/configuration/tagcommander'

import { colors } from '../../theme'
import ActionButton from '../../components/ActionButton'
import tcClick, { TcCLickArgs } from '../tcClick/tcClick'
import { ContentCardVariant } from '../../components/ContentCard/styled'

export const crossLinkCardTransformer = (
  cl: any,
  t: any,
  tcVars?: {
    template: TcPageTemplateNames
  } & TcCLickArgs,
  isOffline?: boolean
) => {
  return {
    backgroundColor: colors.burningOrange,
    imageProps: {
      src: cl?.image ?? '/images/default/placeholder.png',
      alt: cl?.title ?? '',
      objectFit: 'cover',
      layout: 'fill',
      unoptimized: isOffline,
    } as ImageProps,
    firstHighlightText: t(`crosslinks_cta_${cl?.type}`),
    secondHighlightText: cl?.title ?? '',
    variant: ContentCardVariant.Article,
    buttons: (
      <>
        <ActionButton
          text={t(`crosslinks_cta_read_${cl?.type}`)}
          variantType="link"
          disabled={isOffline}
          actionProps={{
            href: cl?.url,
            target: cl.url.includes(process.env.MANGER_BOUGER_ROOT)
              ? '_self'
              : '_blank',
            onClickHandler: () => {
              tcVars &&
                tcClick({
                  click_name: `${t(
                    `crosslinks_cta_read_${cl?.type}`
                  )}__crosslinking__${tcVars?.template}_fam`,
                  click_type: tcVars?.click_type,
                  chapter1: tcVars.chapter1,
                  chapter2: tcVars.chapter2,
                  chapter3: tcVars.chapter3,
                  click: t(`crosslinks_cta_read_${cl?.type}`),
                  click_chapter1: 'article',
                  click_chapter2: cl?.title ?? '',
                })
            },
          }}
        />
      </>
    ),
  }
}
